import "./App.css";
import "./components/Header";
import Header from "./components/Header";
import Memegenerator from "./components/Memegenerator";

function App() {
  return (
    <div className="App">
      <Header />
      <Memegenerator />
    </div>
  );
}

export default App;
